export enum LineOfServiceEnum {
    Hospice = 1,
    PalliativeCare = 2
}
